import type {InterfaceStrings} from './strings'

export const pl: InterfaceStrings = {
    nav: {
        beginSession: 'Zacznij',
        faq: 'Pytania',
        pricing: 'Cennik',
        legal: 'Informacje prawne',
        signIn: 'Zaloguj się',
        viewPricing: 'Zobacz cennik',
        signOut: 'Wyloguj się',
        account: 'Konto',
        menu: 'Menu',
        closeMenu: 'Zamknij menu',
        mainNav: 'Nawigacja główna',
        sessions: {one: '{n} sesja', few: '{n} sesje', many: '{n} sesji', other: '{n} sesji'},
    },
    footer: {
        selfHypnosisFor: 'Autohipnoza na',
        anxiety: 'Lęk',
        sleep: 'Sen',
        stress: 'Stres',
        confidence: 'Pewność siebie',
        focus: 'Koncentrację',
        learn: 'Wiedza',
        ericksonian: 'Czym jest hipnoza ericksonowska',
        aiHow: 'Jak działa hipnoza z AI',
        vsMeditation: 'Hipnoza a medytacja',
        methods: 'Metody',
        languages: 'Języki',
    },
    page: {
        cta: 'Rozpocznij bezpłatną sesję',
        hint: 'Pierwsza sesja jest bezpłatna',
        exploreFurther: 'Czytaj dalej',
        disclaimer:
            'Quies to narzędzie do relaksu i poznawania siebie. Nie jest wyrobem medycznym i nie diagnozuje, nie leczy ani nie wyleczy żadnej choroby. Jeśli przeżywasz kryzys psychiczny, zwróć się do specjalisty.',
        transcript: 'Transkrypcja',
        transcriptNote: 'Fragment prawdziwej sesji Quies, tak jak została wypowiedziana.',
        breadcrumb: 'Ścieżka nawigacji',
    },
    pricing: {
        selectPlan: 'Wybierz pakiet',
        subscribe: 'Subskrybuj',
        perMonth: 'miesięcznie',
        manageSubscription: 'Zarządzaj subskrypcją',
        replayFree: 'Ponowne odsłuchanie minionej sesji jest zawsze bezpłatne.',
        offerLead: 'Każda sesja zaczyna się tam, gdzie skończyła się poprzednia.',
    },
    session: {
        chooseLanguage: 'Wybierz język',
        changeLanguage: 'Zmień język',
        changeVoice: 'Zmień głos',
        previewVoice: 'Posłuchaj głosu: {voice}',
        stopPreview: 'Zatrzymaj próbkę',
        continue: 'Dalej',
        composing: 'Quies pisze twoją sesję',
        preparing: 'Twoja medytacja jest przygotowywana',
        pickingUp: 'wracamy tam, gdzie była przerwa',
        today: 'Dzisiaj',
        yesterday: 'Wczoraj',
        loading: 'Wczytywanie…',
        showEarlier: 'Pokaż wcześniejsze ({count})',
        tryDifferentApproach: 'Spróbuj innej drogi',
        nothingAdded: 'Bez dopisku',
        purchaseConfirmed: 'Zakup potwierdzony',
        firstSessionNote: 'Twoja pierwsza sesja jest bezpłatna. Zalogujesz się, zanim jej posłuchasz.',
    },
    threshold: {
        title: 'Zaloguj się, aby posłuchać',
        message: 'Twoja pierwsza sesja jest bezpłatna. Karta nie jest potrzebna.',
        google: 'Kontynuuj z Google',
        sendLink: 'Wyślij mi link do logowania',
        sending: 'Wysyłanie…',
        emailLabel: 'Adres e-mail',
        or: 'lub',
        waitingTitle: 'Sprawdź skrzynkę e-mail',
        waitingBody: 'Wysłaliśmy link do logowania na adres {email}.',
        sendAgain: 'Wyślij ponownie',
        googleInstead: 'Zamiast tego zaloguj się przez Google',
        codeLabel: 'Albo wpisz 6-cyfrowy kod z e-maila',
        codeSubmit: 'Dalej',
        codeSubmitting: 'Sprawdzanie…',
        codeWrong: 'Ten kod jest nieprawidłowy.',
        codeDead: 'Ten kod już nie działa. Użyj linku z e-maila albo wyślij nowy.',
        errors: {
            invalidEmail: 'Podaj prawidłowy adres e-mail.',
            rateLimited: 'Zbyt wiele prób. Spróbuj ponownie za kilka minut.',
            sessionError: 'Coś poszło nie tak z Twoim logowaniem. Odśwież stronę i spróbuj ponownie.',
            sendFailed: 'Nie udało się wysłać wiadomości. Spróbuj ponownie.',
            sessionExpired: 'Twoje logowanie wygasło. Odśwież stronę i spróbuj ponownie.',
            generic: 'Coś poszło nie tak. Spróbuj ponownie.',
        },
    },
    player: {
        play: 'Odtwórz',
        pause: 'Wstrzymaj',
        playAgain: 'Odtwórz ponownie',
        seek: 'Pozycja',
        eyesClosed: 'Zamknięte oczy',
        openEyes: 'Otwórz oczy',
        paused: 'Wstrzymano',
        unavailable: 'Nagranie niedostępne',
        untitled: 'Sesja Quies',
    },
    failure: {
        turnFailed: 'Coś poszło nie tak po naszej stronie. Twoja odpowiedź została zachowana.',
        reconnecting: 'Ponowne łączenie…',
        refusalTitle: 'Pójdźmy inną drogą',
        refusal: 'Na część twojej wiadomości nie dało się odpowiedzieć. Spróbuj ująć to inaczej albo wyślij ją ponownie.',
        openElsewhere: 'Ta sesja jest otwarta także w innym oknie.',
        serviceDown: 'Quies jest w tej chwili nieosiągalny. Nic, co już zostało zrobione, nie przepadło.',
        sessionsUsedTitle: 'Twoje sesje zostały wykorzystane',
        voiceFailedTitle: 'Twoja medytacja jest napisana',
        voiceFailed: 'Nie udało się teraz nagrać jej głosu. Nic nie przepadło, a ponowne nagranie nic nie kosztuje.',
        voiceStopped: 'Głos urwał się w połowie. Może podjąć od miejsca, w którym przerwał.',
        streamMissing: 'Twoja medytacja jest gotowa, ale nie dotarła na tę stronę.',
        tapToListen: 'Dotknij, aby posłuchać',
        fileFailed: 'Tego nagrania nie da się odtworzyć. Medytację można nagrać ponownie, bez opłat.',
        recordingGone: 'To nagranie nie jest już przechowywane.',
        purchaseCancelled: 'Zakup anulowany. Nic nie zostało pobrane.',
        purchasePending: 'Twoja płatność jest potwierdzona. Sesje docierają dłużej niż zwykle.',
        checkoutFailed: 'Nie udało się dokończyć płatności. Nic nie zostało pobrane.',
        sessionEnded: 'Ta sesja dobiegła końca.',
        busy: 'Quies jest teraz bardzo obciążony. Twoja odpowiedź została zachowana; spróbuj ponownie za minutę.',
        tooLong: 'Ta sesja stała się dłuższa, niż Quies może pomieścić. Została ci zwrócona.',
        notSaved: 'Nie udało się zapisać tego kroku. Spróbuj ponownie, aby nie stracić wątku.',
        meditationRefused:
            'Nie udało się napisać tej medytacji zgodnie z prośbą. Ujmij to inaczej albo zacznij od nowa: ta sesja zostanie ci zwrócona.',
        meditationRefusedUncharged:
            'Nie udało się napisać tej medytacji zgodnie z prośbą. Ujmij to inaczej albo zacznij od nowa.',
        linkExpired: 'Twój link do logowania wygasł. Poproś o nowy.',
        oauthFailed: 'Logowanie zostało przerwane. Spróbuj ponownie.',
        offline: 'Jesteś offline. Twoja odpowiedź zostanie wysłana, gdy tylko wrócisz.',
        voiceChanged: 'Twój głos nie jest już dostępny; tę medytację przeczyta inny głos.',
        voiceReturned: 'Nadal nie udało się nagrać głosu. Ta sesja została ci zwrócona.',
        voiceFailedAgain: 'Nadal nie udało się nagrać głosu.',
        voiceResuming: 'Głos wraca…',
        voiceLimited: 'W tej godzinie nagrano już dla ciebie kilka medytacji. Spróbuj ponownie trochę później.',
        tryAgain: 'Spróbuj ponownie',
        rephrase: 'Ujmij inaczej',
        resume: 'Wznów',
        voiceAgain: 'Nagraj ponownie',
        listen: 'Posłuchaj',
        continue: 'Dalej',
        begin: 'Zacznij sesję',
        signIn: 'Zaloguj się',
        checkAgain: 'Sprawdź ponownie',
        sendLink: 'Wyślij magiczny link',
        useEmail: 'Użyj adresu e-mail',
    },
}
